export const css = {
    root: '_3yK3oFaa',
    scoreblock: 'Pa-lY2sK',
    legend: 'JWfaq4mF',
    scoreIcon: '_25XgvXY3',
    assessIcon: '_2u8_TUhd',
    topicGroup: '_3tDbSbYA',
    ' _key': 'apic-theme/apic/prepost-viz/prepost-viz'
};
export default css;
